export default [
    {
        path: 'relatorio-quantitativo-producao',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-relatorio-quantitativo-producao' */
            '@/views/pronto-atendimento/relatorio-quantitativo-producao/Index'
        ),
        redirect: 'relatorio-quantitativo-producao/index',
        children: [
            {
                name: 'pronto-atendimento-relatorio-quantitativo-producao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-relatorio-quantitativo-producao' */
                    '@/views/pronto-atendimento/relatorio-quantitativo-producao/List'
                ),
            },
        ]
    }
]